import React, { createContext, useState, useContext, useEffect } from "react";

// Create a context for cookie consent
const CookieConsentContext = createContext(undefined);

export const CookieConsentProvider = ({ children }) => {
    const [consentGiven, setConsentGiven] = useState(null);

    // Load stored consent from localStorage on initial render
    useEffect(() => {
        const storedConsent = localStorage.getItem("cookieConsent");
        if (storedConsent) {
            setConsentGiven(JSON.parse(storedConsent));
        }
    }, []);

    // Save the consent state to localStorage whenever it changes
    useEffect(() => {
        if (consentGiven !== null) {
            localStorage.setItem("cookieConsent", JSON.stringify(consentGiven));
        }
    }, [consentGiven]);

    return (
        <CookieConsentContext.Provider value={{ consentGiven, setConsentGiven }}>
            {children}
        </CookieConsentContext.Provider>
    );
};

export const useCookieConsent = () => {
    const context = useContext(CookieConsentContext);
    if (context === undefined) {
        throw new Error(
            "useCookieConsent must be used within a CookieConsentProvider"
        );
    }
    return context;
};
